/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import UAParser from 'ua-parser-js'

import './DesktopModal.scss'

import CheckText from '../CheckText/CheckText'
import Button from '../Buttons/Button/Button'
import Modal from '../Modal/Modal'
import { sendMetric } from '../../../helpers/metric'

const featureTranslationKeys = [
  'desktop-modal.object-removal',
  'desktop-modal.bg-removal',
  'desktop-modal.photo-restoration',
  'desktop-modal.photo-enhancement',
  'desktop-modal.image-retouching',
  'desktop-modal.noise-reduction',
  'desktop-modal.text-insertion',
  'desktop-modal.images-insertion',
]

const downloadLinkWindows = 'https://www.movavi.com/download-picverse44'
const downloadLinkMac = 'https://www.movavi.com/download-picversemac44'
const isWindows = UAParser().os.name === 'Windows'

class DesktopModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onCLose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
  }

  downloadTranslationKey = isWindows ? 'desktop-modal.download-windows' : 'desktop-modal.download-mac'
  altDownloadTranslationKey = isWindows ? 'desktop-modal.i-need-mac' : 'desktop-modal.i-need-windows'

  buttonClickHandler = () => {
    sendMetric({
      event: 'OWOX',
      gtm: {
        eventCategory: 'Conversions',
        eventAction: 'click',
        eventLabel: 'download'
      }
    })

    window.open(
      isWindows ? downloadLinkWindows : downloadLinkMac,
      '_blank'
    )
  }

  linkClickHandler = () => {
    sendMetric({
      event: 'OWOX',
      gtm: {
        eventCategory: 'Conversions',
        eventAction: 'click',
        eventLabel: 'download'
      }
    })
  }

  render() {
    const {
      t,
      isOpen,
      onCLose
    } = this.props

    return (
      <Modal
        isOpen={isOpen}
        prominent
        modalId="gtm-peo-ANB-1559-show-popup-download"
        closeId="gtm-peo-ANB-1559-close-popup-download"
        onCloseModal={onCLose}
      >
        <div className="modal__head">
          {t('desktop-modal.title')}
        </div>
        <div className="modal__body">
          {featureTranslationKeys.map((featureTranslationKey) => (
            <div className="desktop-modal-list-item" key={featureTranslationKey}>
              <CheckText>{t(featureTranslationKey)}</CheckText>
            </div>
          ))}
          <div className="modal__buttons">
            <Button onClick={this.buttonClickHandler} id="gtm-peo-ANB-1559-click-button-download">
              {t(this.downloadTranslationKey)}
            </Button>
            <div className="desktop-modal-alt-download">
              <a
                target="_blank"
                href={isWindows ? downloadLinkMac : downloadLinkWindows}
                onClick={this.linkClickHandler}
              >
                {t(this.altDownloadTranslationKey)}
              </a>
            </div>
            <div className="desktop-modal-note">
              {t('desktop-modal.offers-full')}
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(DesktopModal)
